// extracted by mini-css-extract-plugin
var _1 = "AuthBrand-module__container--R0chN";
var _2 = "AuthBrand-module__downloadButton--dyoeP";
var _3 = "AuthBrand-module__downloadButtonsWrapper--ILT5l";
var _4 = "AuthBrand-module__logoContainer--L0j72";
var _5 = "AuthBrand-module__logoTitle--O0hs3";
var _6 = "AuthBrand-module__subtitle--IYhru";
var _7 = "AuthBrand-module__title--O4QHQ";
export { _1 as "container", _2 as "downloadButton", _3 as "downloadButtonsWrapper", _4 as "logoContainer", _5 as "logoTitle", _6 as "subtitle", _7 as "title" }
